<main>
  <div class="mx-4 mb-10">
    <h3 class="text-4xl font-bold mb-2">Gestão de Ocorrências</h3>
    <p class="text-sm">Faça a gestão das ocorrências criadas na sua conta</p>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-2 mx-4 gap-4">

    <div class="shadow bg-white p-8 cursor-pointer" (click)="toggleRemoveAllEventsEventModal()">
      <header class="text-2xl mb-4"><i class="pi pi-eraser text-xl mr-2 text-blue-500"></i> Remover Ocorrências</header>
      <p class="text-sm">Remover todas as ocorrências criadas por mim</p>
    </div>

    @if (isAdmin) {
      <div class="shadow bg-white p-8 cursor-pointer" (click)="toggleTransferEventsModal()">
        <header class="text-2xl mb-4"><i class="pi pi-send text-xl mr-2 text-blue-500"></i> Transferir Ocorrências</header>
        <p class="text-sm">Transferir as minhas ocorrências para outro moderador</p>
      </div>
    }

  </div>

  <app-modal [header]="'Remover todas Ocorrências'"
    [isShow]="showRemoveEventsModal"
    [style]="'w-auto max-w-md'"
    (cancel)="showRemoveEventsModal = false">
    <app-remove-all-events-modal (onCloseModal)="showRemoveEventsModal = false"></app-remove-all-events-modal>
  </app-modal>

  <app-modal [header]="'Transferir todas Ocorrências'"
    [isShow]="showTransferEventsModal"
    [style]="'w-auto max-w-md'"
    (cancel)="showTransferEventsModal = false">
    <app-transfer-all-events-modal (onCloseModal)="showTransferEventsModal = false"></app-transfer-all-events-modal>
  </app-modal>
</main>
